import { render, staticRenderFns } from "./ThoughtOfTheDay.vue?vue&type=template&id=7f3d5d46&"
import script from "./ThoughtOfTheDay.vue?vue&type=script&lang=js&"
export * from "./ThoughtOfTheDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports